export default "__VITE_ASSET__9J4aaF_n__"